import React, { useMemo, useState } from "react"
import clsx from "clsx"
import Link from "next/link"
import { useRouter } from "next/router"
import S from "./product-filters-group.module.scss"
import SearchIcon from "../svgs/search.svg"

type Props = {
  title?: string
  basePath?: string
  values: {
    slug: string
    name: string
    count: number
  }[]
}

const ProductFiltersGroup: React.FC<Props> = ({
  title = "Product Type",
  basePath,
  values,
}) => {
  const router = useRouter()
  const [searchQuery, setSearchQuery] = useState<string | undefined>(undefined)
  const filteredValues = useMemo(() => {
    if (!searchQuery) {
      return values
    }

    return values.filter((item) =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase()),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery])

  return (
    <div className={S.wrapper}>
      <p className={S.subtitle}>{title}</p>
      <div className={S.inputWrapper}>
        <input
          type="input"
          className={clsx("form-control", S.input)}
          placeholder={`Search ${title.toLowerCase()}`}
          onKeyUp={(e) => setSearchQuery((e.target as HTMLInputElement).value)}
        />
        <SearchIcon />
      </div>
      <ul className={S.list}>
        {filteredValues.map((item) => (
          <li key={item.slug}>
            <Link
              href={basePath ? `${basePath}/${item.slug}` : item.slug}
              className={clsx(S.value, {
                [S.active]: [
                  router.query.slug,
                  router.query.componentType,
                  router.query.fabricType,
                ].includes(item.slug),
              })}
            >
              {item.name}
              <span>({item.count})</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ProductFiltersGroup
